(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  // Copy link functionality
  document.addEventListener('DOMContentLoaded', function() {
    const copyButtons = document.querySelectorAll('.article-share__button--copy');

    copyButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const url = this.getAttribute('data-copy-url');

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() {
            button.classList.add('copied');
            setTimeout(function() {
              button.classList.remove('copied');
            }, 2000);
          });
        } else {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = url;
          textArea.style.position = 'fixed';
          textArea.style.left = '-9999px';
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            button.classList.add('copied');
            setTimeout(function() {
              button.classList.remove('copied');
            }, 2000);
          } catch (err) {
            console.error('Failed to copy URL');
          }
          document.body.removeChild(textArea);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const cards = document.querySelectorAll('.categories-section .scroll-fade-in');
    cards.forEach(function(card, index) {
      card.style.transitionDelay = (index * 0.1) + 's';
      observer.observe(card);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  // Handle collection sorting
  document.addEventListener('DOMContentLoaded', () => {
    const sortSelect = document.getElementById('sort-by');
    if (!sortSelect) return;

    // Get current sort_by from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by') || 'manual';
    
    // Set selected option based on current URL
    sortSelect.value = currentSort;

    // Handle sort change
    sortSelect.addEventListener('change', (e) => {
      const newSort = e.target.value;
      
      // Update URL with new sort parameter
      const url = new URL(window.location.href);
      if (newSort === 'manual') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', newSort);
      }
      
      // Navigate to new URL
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Toggle form visibility
    document.querySelectorAll('[data-action="toggle-form"]').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-target');
        const target = document.getElementById(targetId);
        if (target) {
          target.style.display = target.style.display === 'none' ? 'block' : 'none';
        }
      });
    });

    // Delete address
    document.querySelectorAll('[data-action="delete-address"]').forEach(btn => {
      btn.addEventListener('click', () => {
        const confirmMsg = btn.getAttribute('data-confirm');
        if (confirm(confirmMsg)) {
          const url = btn.getAttribute('data-target');
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = url;

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = '_method';
          input.value = 'delete';
          form.appendChild(input);

          document.body.appendChild(form);
          form.submit();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const recoverToggle = document.getElementById('RecoverPasswordToggle');
    const recoverCancel = document.getElementById('RecoverPasswordCancel');
    const recoverForm = document.getElementById('RecoverPasswordForm');
    const loginContent = document.querySelector('.login-page__content');

    if (recoverToggle && recoverForm && loginContent) {
      recoverToggle.addEventListener('click', (e) => {
        e.preventDefault();
        loginContent.style.display = 'none';
        recoverForm.style.display = 'block';
      });
    }

    if (recoverCancel && recoverForm && loginContent) {
      recoverCancel.addEventListener('click', () => {
        recoverForm.style.display = 'none';
        loginContent.style.display = 'block';
      });
    }

    // Auto-show recover form if hash is present
    if (window.location.hash === '#recover' && recoverForm && loginContent) {
      loginContent.style.display = 'none';
      recoverForm.style.display = 'block';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Subtle scroll-triggered animation for footer elements
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const animateOnScroll = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  };

  const observer = new IntersectionObserver(animateOnScroll, observerOptions);

  document.addEventListener('DOMContentLoaded', () => {
    const footerElements = document.querySelectorAll('.site-footer__brand, .site-footer__menu');

    footerElements.forEach((el, index) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `all 0.6s cubic-bezier(0.4, 0, 0.2, 1) ${index * 0.1}s`;
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const mobileToggle = document.querySelector('.site-header__mobile-toggle');
    const mobileMenu = document.querySelector('.site-header__mobile-menu');
    const cartCountElement = document.querySelector('.site-header__cart-count');

    // Scroll detection for header styling
    let lastScrollY = window.scrollY;

    function handleScroll() {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 50) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }

      lastScrollY = currentScrollY;
    }

    // Throttle scroll events for performance
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = window.requestAnimationFrame(handleScroll);
    });

    // Initial check on page load
    handleScroll();

    // Mobile menu toggle
    if (mobileToggle && mobileMenu) {
      let scrollPosition = 0;

      function openMenu() {
        scrollPosition = window.scrollY;
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mobile-menu-open');
        document.body.style.top = `-${scrollPosition}px`;
      }

      function closeMenu() {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mobile-menu-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
      }

      mobileToggle.addEventListener('click', () => {
        const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      // Close mobile menu when clicking outside
      document.addEventListener('click', (e) => {
        if (!header.contains(e.target) && mobileMenu.getAttribute('aria-hidden') === 'false') {
          closeMenu();
        }
      });

      // Close menu on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
          closeMenu();
        }
      });
    }

    // Update cart count when items are added
    function updateCartCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cartCountElement) {
            cartCountElement.textContent = cart.item_count;
          }
        })
        .catch(error => {
          console.error('Error updating cart count:', error);
        });
    }

    // Listen for cart:add event from product page
    document.addEventListener('cart:add', updateCartCount);

    // Also update on cart:update event (for cart page changes)
    document.addEventListener('cart:update', updateCartCount);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  // Fade-in animation for hero section elements
  document.addEventListener('DOMContentLoaded', () => {
    const heroSection = document.querySelector('.hero-section');
    if (heroSection) {
      // Trigger animation after a brief delay
      setTimeout(() => {
        heroSection.classList.add('hero-section--loaded');
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-newsletter-popup]');
    if (!popup || typeof popup.showModal !== 'function') return;

    const DISMISSED_KEY = 'newsletter_popup_dismissed_at';
    const SUBSCRIBED_KEY = 'newsletter_subscribed';
    const frequencyDays = parseInt(popup.dataset.frequencyDays, 10) || 30;

    const store = {
      get(key) {
        try {
          return localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set(key, value) {
        try {
          localStorage.setItem(key, value);
        } catch (error) {
          /* navigation privee */
        }
      },
    };

    const dismiss = () => {
      store.set(DISMISSED_KEY, String(Date.now()));
      if (popup.open) popup.close();
    };

    popup.querySelector('[data-newsletter-popup-close]').addEventListener('click', dismiss);
    // Esc et clic sur le fond ferment aussi : on enregistre le refus dans les deux cas.
    popup.addEventListener('close', () => store.set(DISMISSED_KEY, String(Date.now())));
    popup.addEventListener('click', (event) => {
      if (event.target === popup) dismiss();
    });

    // Retour d'inscription : Shopify recharge la page, on rouvre pour montrer la confirmation.
    let lastSource = null;
    try {
      lastSource = sessionStorage.getItem('newsletter_last_source');
      sessionStorage.removeItem('newsletter_last_source');
    } catch (error) {
      /* noop */
    }

    if (popup.querySelector('.newsletter-form--posted')) {
      if (lastSource === 'popup') popup.showModal();
      return;
    }

    if (store.get(SUBSCRIBED_KEY)) return;

    const dismissedAt = parseInt(store.get(DISMISSED_KEY), 10);
    if (dismissedAt && Date.now() - dismissedAt < frequencyDays * 86400000) return;

    let opened = false;
    const open = () => {
      if (opened || popup.open) return;
      opened = true;
      popup.showModal();
    };

    const delay = parseInt(popup.dataset.delay, 10);
    if (delay > 0) setTimeout(open, delay * 1000);

    const scrollTarget = parseInt(popup.dataset.scroll, 10);
    if (scrollTarget > 0) {
      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        if ((window.scrollY / scrollable) * 100 >= scrollTarget) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Intention de sortie : le curseur quitte la fenetre par le haut. Desktop uniquement,
    // il n'existe pas d'equivalent fiable au tactile - le scroll et le delai couvrent le mobile.
    if (popup.dataset.exitIntent === 'true' && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget && event.clientY <= 0) open();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Filter functionality
  document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.search-meta__filter');
    const searchCards = document.querySelectorAll('.search-card');
    
    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const filterType = this.dataset.filter;
        
        // Update active state
        filterButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Filter cards
        searchCards.forEach(card => {
          const cardType = card.dataset.type;
          if (filterType === 'all' || cardType === filterType) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
    
    // Set initial active state
    if (filterButtons.length > 0) {
      filterButtons[0].classList.add('active');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
